import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { PlanTierSchema } from './backoffice';
const c = initContract();
// Workspace DTO
export const WorkspaceSchema = z.object({
    id: z.string(),
    name: z.string(),
    uname: z.string(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    tier: PlanTierSchema,
    members: z.array(z.object({
        id: z.string(),
        firstName: z.string(),
        lastName: z.string(),
        email: z.string(),
    })),
    /** Set when the workspace is a client of a consultant organization. */
    consultantOrganization: z
        .object({
        id: z.string(),
        name: z.string(),
        logo: z.string().nullable(),
    })
        .nullable()
        .optional(),
});
const UpdateWorkspaceMembersSchema = z.object({
    workspaceId: z.string(),
    memberIds: z.array(z.string()),
});
const CreateWorkspaceSchema = z.object({
    name: z.string().min(1, 'Workspace name is required'),
    uname: z
        .string()
        .min(1, 'Workspace uname is required')
        .regex(/^[a-z0-9-]+$/, 'Workspace uname must contain only lowercase letters, numbers, and hyphens'),
    userIds: z.array(z.string()).optional().default([]),
});
// ── Contact Request (upgrade) ──
export const ContactRequestBodySchema = z.object({
    type: z.enum(['callback', 'email', 'meeting']),
    phoneNumber: z.string().optional(),
});
export const workspaceContract = c.router({
    getUserWorkspaces: {
        method: 'GET',
        path: '/workspaces',
        summary: 'Get all workspaces accessible to the current user',
        responses: {
            200: c.type(),
            401: c.type(),
        },
    },
    getUserWorkspacesForSidebar: {
        method: 'GET',
        path: '/workspaces/sidebar',
        summary: 'Get all workspaces accessible to the current user for sidebar',
        responses: {
            200: c.type(),
            401: c.type(),
        },
    },
    createWorkspace: {
        method: 'POST',
        path: '/workspaces',
        summary: 'Create new workspace (admin)',
        body: CreateWorkspaceSchema,
        responses: {
            201: z.object({
                workspaceId: z.string(),
            }),
            400: z.object({
                message: z.string(),
                statusCode: z.number(),
            }),
            401: z.object({
                message: z.string(),
                statusCode: z.number(),
            }),
            409: z.object({
                message: z.string(),
                statusCode: z.number(),
            }),
        },
    },
    sendContactRequest: {
        method: 'POST',
        path: '/workspaces/contact-request',
        summary: 'Send a contact request for plan upgrade',
        body: ContactRequestBodySchema,
        responses: {
            200: z.object({ message: z.string(), calUrl: z.string().optional() }),
            401: z.object({ message: z.string() }),
        },
    },
    updateWorkspaceMembers: {
        method: 'POST',
        path: '/workspaces/updateMembers',
        summary: 'Update workspace members assignments (admin)',
        body: UpdateWorkspaceMembersSchema,
        responses: {
            200: z.object({
                workspaceId: z.string(),
            }),
            401: z.object({
                message: z.string(),
                statusCode: z.number(),
            }),
            404: z.object({
                message: z.string(),
                statusCode: z.number(),
            }),
        },
    },
});
//# sourceMappingURL=workspace.js.map